/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} FileInputs */

const en_file = /** @type {(inputs: FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File`)
};

const fr_file = /** @type {(inputs: FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fichier`)
};

const de_file = /** @type {(inputs: FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datei`)
};

const it_file = /** @type {(inputs: FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File`)
};

const ru_file = /** @type {(inputs: FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Файл`)
};

const es_file = /** @type {(inputs: FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivo`)
};

const zh_cn2_file = /** @type {(inputs: FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件`)
};

const ja_file = /** @type {(inputs: FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイル`)
};

const hi_file = /** @type {(inputs: FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल`)
};

const pt_pt2_file = /** @type {(inputs: FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arquivo`)
};

/**
* | output |
* | --- |
* | "File" |
*
* @param {FileInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file = /** @type {((inputs?: FileInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<FileInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file(inputs)
	if (locale === "de") return de_file(inputs)
	if (locale === "it") return it_file(inputs)
	if (locale === "ru") return ru_file(inputs)
	if (locale === "es") return es_file(inputs)
	if (locale === "zh-CN") return zh_cn2_file(inputs)
	if (locale === "ja") return ja_file(inputs)
	if (locale === "hi") return hi_file(inputs)
	if (locale === "pt-PT") return pt_pt2_file(inputs)
	return en_file(inputs)
});